import type { WireBaseComponent } from "../../wire/base-components";
import { WireComponentKind } from "../../wire/component-kind";
import { UIBackgroundStyle } from "../../wire/types";
import type { WireButtonComponent } from "./fluent-components";
import type { WirePropertiesOfComponent } from "./fluent-components-spec";
import { ContainerKind, emptyProperties, FluentComponent, properties } from "./fluent-components-spec";

function container<TKind extends WireComponentKind>(kind: TKind) {
    return new FluentComponent<
        unknown,
        unknown,
        { readonly kind: TKind; readonly components: readonly (WireBaseComponent | null)[] }
    >({
        kind,
        containerKind: ContainerKind.Regular,
        properties: emptyProperties,
        formProperties: emptyProperties,
    });
}

function formContainer<TKind extends WireComponentKind>(kind: TKind) {
    return new FluentComponent<
        unknown,
        unknown,
        {
            readonly kind: TKind;
            readonly components: readonly (WireBaseComponent | null)[];
            readonly specialButtons: readonly (WireButtonComponent | null)[];
        }
    >({
        kind,
        containerKind: ContainerKind.Form,
        properties: emptyProperties,
        formProperties: emptyProperties,
    });
}

const containerProperties = properties.withEnum("containerStyle", [
    UIBackgroundStyle.None,
    UIBackgroundStyle.Highlight,
    UIBackgroundStyle.Accent,
]);

// NOTE: These are all our container components.  When adding a new one, make
// sure to add it do ##isWireContainerComponent.
export const Container = container(WireComponentKind.Container)
    .withDisplayName("Container")
    .withIcon("mt-component-container")
    .withProperties(containerProperties);
export type WireContainerComponent = WirePropertiesOfComponent<typeof Container>;

export const FormContainer = formContainer(WireComponentKind.FormContainer)
    .withDisplayName("Form Container")
    .withFeatureSetting("formContainer")
    .withIcon("mt-component-container")
    .withProperties(containerProperties);
export type WireFormContainerComponent = WirePropertiesOfComponent<typeof FormContainer>;
